import React, { useState, useEffect } from 'react';
import { Box, TextField, InputAdornment, Popover, MenuItem } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useListContext } from 'react-admin';
import { API, graphqlOperation } from 'aws-amplify';

// GraphQL query to fetch sites
const listSites = /* GraphQL */ `
  query ListSites {
    listSites {
      items {
        id
        name
      }
    }
  }
`;

const LogsFilterBar = () => {
  const { filterValues, setFilters, displayedFilters } = useListContext();

  // State for site selection
  const [sites, setSites] = useState([]);
  const [siteValue, setSiteValue] = useState(filterValues.site || ''); // Save site name

  // States for Popover (for site)
  const [anchorSiteEl, setAnchorSiteEl] = useState(null);
  const siteOpen = Boolean(anchorSiteEl);

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const response = await API.graphql(graphqlOperation(listSites));
        setSites(response.data.listSites.items);
      } catch (error) {
        console.error('Error fetching sites:', error);
        setSites([]);
      }
    };
    fetchSites();
  }, []);

  // Handle site selection from the Popover
  const handleSiteSelect = (siteName) => {
    setSiteValue(siteName); // Set the selected site value
    setAnchorSiteEl(null); // Close the Popover
    // Apply the filter
    const newFilters = {
      ...filterValues,
      site: siteName || undefined,
    };
    setFilters(newFilters, displayedFilters); // Apply the selected site filter to URL params
  };

  // Open the site popover
  const handleSiteOpen = (event) => {
    setAnchorSiteEl(event.currentTarget);
  };

  // Close the site popover
  const handleSiteClose = () => {
    setAnchorSiteEl(null);
  };

  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      {/* Site filter popover */}
      <TextField
        label="Select Site"
        variant="outlined"
        size="small"
        value={siteValue}
        placeholder="Select site"
        onClick={handleSiteOpen} // Open popover when clicked
        sx={{ minWidth: 200 }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <ArrowDropDownIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />

      <Popover
        open={siteOpen}
        anchorEl={anchorSiteEl}
        onClose={handleSiteClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ minWidth: 200, maxHeight: 500, overflowY: 'auto', padding: '10px' }}>
          <MenuItem value="" onClick={() => handleSiteSelect('')}>All Sites</MenuItem>
          {sites.map((site) => (
            <MenuItem key={site.id} onClick={() => handleSiteSelect(site.name)}>
              {site.name}
            </MenuItem>
          ))}
        </Box>
      </Popover>
    </Box>
  );
};

export default LogsFilterBar;
export { LogsFilterBar };
